import React from "react";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import ModalBox from "../../../components/common/ModalBox";

function ErrorModal({ open, setOpen }) {

    const history = useHistory()

    const handleSubmit = () => {
        history.push('/')
        setOpen(false)
    }

    return (
        <ModalBox
        open={open}
        setOpen={setOpen}
        noActionOnOutsideClick={true}
        >
            <div className="flex fd-column jc-space-between items-center">
                <div className="text-center font-bold-500 font-size-18  ">
                    This conference is currently inactive, or you do not have authorization to access it
                </div>
                <div className='mt-20 text-center'>
                    Don’t worry though, everything is still awesome.
                </div>
                <div className='mt-20 text-center'>
                    <Button type='primary' onClick={handleSubmit}>
                        Return to Home Page
                    </Button>
                </div>
            </div>
            
        </ModalBox>
    );
}

export default ErrorModal;
